<template>
    <card class="content business">
        <span slot="title">
            交易信息
        </span>

        <el-link 
        slot="title-r"
        :underline="false" 
        type="primary"
        href="/business"
        >
            查看更多>
        </el-link>

        <search-bar
            v-model="pgData"
            @change="queryData"
        ></search-bar>

        <el-divider
            class="divider"
        ></el-divider>

        <list
        :data="tableData"
        :props="{title:'GGNAME', time:'GGFBTIME'}"
        :href="hrefBuilder"
        >
            <div slot-scope="scope">
                【{{scope.row.TYPENAME}}】
                【{{scope.row.CITYNAME}}】
                {{scope.row.GGNAME}}
            </div>
        </list>
    </card>
</template>

<script>
import List from '@components/sys/list';
import Card from '@components/sys/card';
import SearchBar from '../../business/components/search-bar';

export default {
    components: {
        List,
        SearchBar,
        Card,
    },
    data() {
        return {
            pgData: {
                type: 'all',
                leixing: '全部',
                citycode: this.$siteConfig.citycode,
                featurecode:this.$siteConfig.planName,
            },

            tableData: [],

            loadingController: false,
        };
    },
    methods: {
        queryData() {
            this.loadingController = true;

            this.$get(`${this.$store.state.api.webUrl}/index/information/getjyinfo.json`, {
                ...this.pgData,
                maxrow: 8,
            }, data => {
                this.tableData = data;

                this.loadingController = false;
            });
        },
        hrefBuilder(item) {
            var search = toSearch({
                ggcode: item.GGCODE,
                categoryid: item.GGTYPE
            });

            if (/SD/.test(item.GGCODE)) {
                return `/business/detail-sd${search}`
            }

            return `/business/detail${search}`;
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
.business{
    margin-top: 12px;
    min-height: 564px;
    margin-bottom: 40px;

    .divider{
        margin: 10px 0 20px;
    }
}
</style>